import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {DipRegistrationService} from '../../dip-registration.service';
import {DipRegistrationLoggerService} from '../../core/services/logger/dip-registration-logger.service';
import {DipRegistrationErrorsHandler} from '../../dip-registration-error/dip-registration-errors.handler';

@Component({
    selector: 'dip-registration-expiration-modal',
    templateUrl: './dip-registration-expiration-modal.component.html',
    styleUrls: ['./dip-registration-expiration-modal.component.scss'],
    standalone: false
})
export class DipRegistrationExpirationModalComponent implements OnInit {
  @Input() limit: number;
  @Output() close = new EventEmitter<void>();
  minutes: string;
  seconds: string;

  constructor( private logger: DipRegistrationLoggerService,
               private errorHandler: DipRegistrationErrorsHandler,
               private readonly dipRegistrationService: DipRegistrationService) {
  }

  ngOnInit() {
    this.updateTime();
    const interval = setInterval(() => {
      const delta = this.updateTime();
      if (delta <= 0) {
        clearInterval(interval);
      }
    }, 1000);
  }

  updateTime() {
    const delta = Math.trunc((this.limit - Date.now()) / 1000);
    this.minutes = String(Math.trunc(delta / 60));
    this.seconds = String(delta % 60).padStart(2, '0');
    return delta;
  }

  async resume() {
    this.close.emit();
    try {
      await this.dipRegistrationService.initContext();
    } catch (err) {
      this.logger.error('Error getting the context', err);
      this.errorHandler.handleMaintenancePageRedirection('APP_INIT_ERROR');
    }
  }
}
